import {useId,View,AccordionView} from "vritra";
import css from "./Preview.module.css";
import {cog0,edit0} from "Assets";


export default function Preview(props){
    const {parent,id=useId("preview")}=props;
    const preview=View({parent,id,className:css.preview});

    preview.innateHTML=`
    `;
    statics.acdviewprops.forEach(acdviewprops=>{
        AccordionView({
            ...acdviewprops,
            parent:preview,
            className:css.accordionview,
            renderContent:({parent:container})=>{
                const view=View({
                    parent:container,
                    className:css.acdcontent,
                });
                view.innateHTML=`
                    <p class="${css.text}">${acdviewprops.title} content</p>
                `;
                return view;
            },
        });
    });


    return preview;
}


const statics={
    acdviewprops:[
        {title:"default"},
        {
            title:"with actions",
            actions:[{id:"edit",icon:edit0},{id:"set",icon:cog0}],
        },
        {
            title:"separate true",
            separate:true,
            containerClassName:css.separatecontent,
            headerClassName:css.header,
        },
        {
            title:"separate false",
            headerClassName:css.header,
        },
        {
            title:"separate false when should be true",
            containerClassName:css.separatecontent,
            headerClassName:css.header,
        },
        {
            title:"separate true when should be false",
            separate:true,
            headerClassName:css.header,
        },
        {title:"locked",locked:true},
    ],
}
